import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'

import * as ActionTypes from '../actions'

export default function comments(state = {}, { type, payload }) {
  switch (type) {
    case ActionTypes.SET_COMMENTS: {
      return payload
    }
    case ActionTypes.UPDATE_COMMENT: {
      return state.map((c) => {
        if (c.id !== payload.id) {
          return c
        }

        return { ...c, ...payload }
      })
    }
    case ActionTypes.DELETE_COMMENT: {
      return state.filter((c) => c.id !== payload.id)
    }
    case ActionTypes.ADD_COMMENT: {
      return [...state, payload]
    }
    default:
      return state
  }
}

export const showComments =
  (commentable, type = 'node') =>
  (dispatch, getState) => {
    if (
      type === 'block' &&
      !migrationProjectSelector.getProjectBlockUnsafe(commentable)(getState())
    ) {
      return
    }

    if (
      type === 'node' &&
      !migrationProjectSelector.getProjectNodeByIdUnsafe(commentable)(
        getState()
      )
    ) {
      return
    }

    dispatch({
      type: ActionTypes.SHOW_COMMENTS,
      payload: { commentable, type },
    })
  }
